// extracted by mini-css-extract-plugin
export default {"countdownLine":"CountdownLine_countdownLine__gZYjV","slideUp":"CountdownLine_slideUp__31Qz8","slideDown":"CountdownLine_slideDown__OwYB6"};